import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function Videos() {
  const { videoId } = useParams();
  console.log(useParams());
  const [element, setElement] = useState(
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "45px",
        height: "calc(100vh - 165px)",
        width: "100%",
        backgroundColor: "#000",
        color: "#fff",
      }}
    >
      <h1 style={{ fontSize: 36 }}>Please wait...</h1>
    </div>,
  );
  useEffect(() => {
    fetch("https://smart-cdn.vkpublications.com/json/vimeo-video.json", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((videos) => {
        const obj = videos.filter((f) => f.guid.trim() === videoId)[0];
        if (obj?.content_type === "video") {
          setElement(
            <div className="video-container">
              <iframe
                className="video-iframe"
                src={`https://player.vimeo.com/video/${obj?.uuid}?autoplay=1&loop=1`}
                title="VK Global Video Player"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                data-ready="true"
              />
            </div>,
          );
        } else {
          window.location.href = obj?.uuid;
        }
      });
  }, [videoId]);

  return element;
}

export default Videos;
